import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { VariationOptionGroup } from 'ish-core/models/product-variation/variation-option-group.model';

@Component({
  selector: 'ish-product-variation-select-default',
  templateUrl: './product-variation-select-default.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ProductVariationSelectDefaultComponent {
  readonly group = input.required<VariationOptionGroup>();
  readonly uuid = input<string>(undefined);
  readonly multipleOptions = input<boolean>(undefined);

  readonly changeOption = output<{
    group: string;
    value: string;
  }>();
  optionChange(group: string, target: EventTarget) {
    this.changeOption.emit({ group, value: (target as HTMLDataElement).value });
  }
  hasActiveElement() {
    return this.group().options.some(item => item.active);
  }
}
